import { Badge, Box, Divider, Group, Stack, Table, Text } from '@mantine/core';
import { useMemo } from 'react';

import { useGetPermissions } from '../api/getPermissions';
import { PERMISSION_GROUP_ICONS } from '../utils/icons';
import { groupPermissions } from '../utils/permissions';

type Props = {
  permissions: string[];
};

export const RolePermissionsCell = ({ permissions }: Props) => {
  const { data: permissionsData } = useGetPermissions();
  const permissionLabelMap = useMemo(
    () => new Map((permissionsData?.permissions ?? []).map(({ key, label }) => [key, label])),
    [permissionsData]
  );

  return (
    <Table.Td>
      <Stack gap={4}>
        {groupPermissions(permissions).map(({ group, color, variant, keys }) => {
          const isSpecialGroup = group === '__wildcard__' || group === '—';
          return (
            <Stack key={group} gap={3} mb={isSpecialGroup ? 0 : 4}>
              {!isSpecialGroup && (
                <Divider
                  my={2}
                  label={
                    <Group gap={4} align="center">
                      {PERMISSION_GROUP_ICONS[group] && (
                        <Box style={{ opacity: 0.5, display: 'flex' }}>
                          {PERMISSION_GROUP_ICONS[group](12)}
                        </Box>
                      )}
                      <Text size="xs" c="dimmed" fw={500}>
                        {group}
                      </Text>
                    </Group>
                  }
                  labelPosition="left"
                />
              )}
              {keys.map((permission) => (
                <Badge
                  key={permission}
                  variant={variant}
                  color={color}
                  radius="sm"
                  size="sm"
                  style={{ alignSelf: 'flex-start' }}
                >
                  {permissionLabelMap.get(permission) ?? permission}
                </Badge>
              ))}
            </Stack>
          );
        })}
      </Stack>
    </Table.Td>
  );
};
